export enum SiteKeyEnum {
	KOUTRAVO= 'koutravo',
	LADRESSE= 'ladresse',
	SELOGER= 'seloger',
	LFIMMO= 'lfimmo',
	CADASTRE= 'cadastre',
	KOUTRAVOFREE= 'koutravofree',
	INNOVIA= 'innovia',
	ARTHURIMMO= 'arthurimmo',
	CAPIFRANCE= 'capifrance',
	OPTIMHOME= "optimhome",
	WEINVESTAGENT= "weinvestagent",
	WEINVESTCLIENT= "weinvestclient",
	LOISELETDAIGREMONT = "loiselet",
	SOLALRENOV = "solalrenov",
	AGENCEPLUS = "agenceplus",
	LALOUPEIMMO = "laloupeimmo",
	KTVEXTERNAL = "ktvexternal"
}
